/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';

import io from "socket.io-client";

export const LiveSyncMixin = {
  data: () => ({
    room_type: 'project'
  }),
  components: {

  },
  computed: {
    ...mapGetters('View', [
      'getCurrentProjectActiveUsers',
    ]),
    ...mapGetters('Auth', [
      'getUserLiveSync',
      'hasPermission',
      'getToken',
      'getIDToken'
    ]),
  },
  methods: {
    startUltraSocket(){
      if (this.hasPermission('Use Live Sync') && process.env.VUE_APP_LIVE_SYNC_SERVER_URL !== 'false' && localStorage.getItem('live_sync') !== "false") {
        if ( !this.$socket ) {
          // INIT this.$socket if it's not already there
          Vue.prototype.$socket = io(process.env.VUE_APP_LIVE_SYNC_SERVER_URL, {
            extraHeaders: {
              'TAKTAccess': this.getToken,
              'TAKTId': this.getIDToken,
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              'Pragma': 'no-cache',
              'Expires': '0'
            },
            path: process.env.VUE_APP_LIVE_SYNC_SERVER_PATH
          });
        }

        // JOIN THE PROJECT ROOM
        // TODO: join rooms generic (project, work package, etc)
        this.$socket.emit('join_project', this.project_id, this.getUserLiveSync);

        // LISTEN TO THE RELEVANT EVENTS

        // join_success: fires whenever a user successfully joins the room
        this.$socket.on('join_success', (id, users, editor) => {
          this.setCurrentProjectSocketData({ id: id, users: users, editor: editor});
        });

        // leave_success: fires whenever a user successfully leaves the room
        this.$socket.on('leave_success', (id, users) => {
          this.setCurrentProjectSocketData({ id: id, users: users, editor: false});
        });

        // takt-update: fires whenever an update (Create,Update,Delete) has been pushed to the room
        this.$socket.on('takt-update', (payload) => {
          if (payload.user !== this.getUserLiveSync.id) {
            switch (payload.command) {
              case 'edit_mode':
                this.setCurrentProjectSocketData({ users: this.getCurrentProjectActiveUsers, editor: payload.data.user });
                break;
              case 'update':
                if (payload.data.position) {
                  this.updateUDObjectPosition({ update: payload.data, url: payload.url });
                } else {
                  this.updateUDObject({ update: payload.data, url: payload.url });
                }
                break;
              case 'update_bulk':
                if (payload.data.updates[0].position) {
                  let bulk = {
                    parents: payload.parents,
                    targets: payload.targets,
                    updates: payload.data.updates,
                  };
                  this.updateUDObjectPosition({ bulk: bulk, url: payload.url });
                } else {
                  let bulk = {
                    parents: payload.parents,
                    targets: payload.targets,
                    updates: payload.data.updates,
                  };
                  this.updateUDObject({ bulk: bulk, url: payload.url });
                }
                break;
              case 'create':
                this.createUDObjectNoFake({ resp_data: payload.data, url: payload.url });
                break;
              case 'create_bulk':
                this.createUDObjectNoFake({ bulk: {
                  parents: payload.parents,
                  targets: payload.targets
                }, resp_data: payload.data, url: payload.url });
                break;
              case 'delete':
                this.deleteUDObject({ url: payload.url });
                break;
              case 'delete_bulk':
                this.deleteUDObject({ url: payload.url, bulk: { parents: payload.parents, targets: payload.targets }});
                break;
            }
          }
        });
      }
    },
    leaveLiveSyncRoom(){
      if ( this.hasPermission('Use Live Sync') && process.env.VUE_APP_LIVE_SYNC_SERVER_URL !== 'false' && localStorage.getItem('live_sync') !== "false") {
        this.$socket.emit('leave_project', this.project_id, this.getUserLiveSync);
      }
    },
    ...mapActions('View', [
      'setCurrentProjectSocketData'
    ]),
    ...mapActions('UltraDev', [
      'createUDObjectNoFake',
      'updateUDObject',
      'deleteUDObject',
      'addUDObjects',
      'removeUDObjects',
      'updateUDObjectPosition',
      'changeUDObjectParent',
      'updateUDObjectRelations',
    ]),
  }
};
